import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BreadcrumbIntegrationLabel from "./BreadcrumbIntegrationLabel";
import type { Integration } from "./Breadcrumbs";

interface InstanceIdBreadcrumbsProps {
  basePath: string;
  baseText: React.ReactNode;
  integrations?: Integration[];
  instanceDisplayProperty: string;
}

const InstanceIdBreadcrumbs: React.FC<InstanceIdBreadcrumbsProps> = ({
  basePath,
  baseText,
  integrations,
  instanceDisplayProperty,
}) => {
  const { t } = useTranslation();
  const { integrationId, instanceId } = useParams<{
    integrationId: string;
    instanceId: string;
  }>();

  if (!integrations?.length) {
    return (
      <div>
        <Link to={basePath}>{baseText} </Link>/ . . . / . . .
      </div>
    );
  }

  const selectedIntegration = integrations?.find(
    (integration) => integration?.id === integrationId
  );

  const selectedInstance = selectedIntegration?.instances?.find(
    (instance) => instance?.id === instanceId
  );

  return (
    <div>
      <Link to={basePath}>{baseText}</Link> /{" "}
      <Link to={`${basePath}/${integrationId}`}>
        <BreadcrumbIntegrationLabel integration={selectedIntegration} />
      </Link>{" "}
      / {(selectedInstance?.[instanceDisplayProperty] as React.ReactNode) ||
        t("New Instance")}
    </div>
  );
};

export default InstanceIdBreadcrumbs;
